import { getContentByRef } from './get-content-by-ref.js';
import { getPrescriptionEntryList } from './get-prescription-entry-list.js';

function getConfiguratorDocument(configuratorDocumentRef, pageModel, noAddonsImage) {
    if (!pageModel) {
        return undefined;
    }
    var ref;
    const { addOnStepReadMore , packageStepReadMore , prescriptionStepDescription , prescriptionStepImage , prescriptionFormStepDescription , prescriptionFormStepImage ,  } = (ref = getContentByRef(configuratorDocumentRef === null || configuratorDocumentRef === void 0 ? void 0 : configuratorDocumentRef.$ref, pageModel)) !== null && ref !== void 0 ? ref : {};
    const entryTypes = getPrescriptionEntryList(configuratorDocumentRef, pageModel);
    return {
        prescriptionStep: {
            entryTypes
        },
        prescriptionUploadStep: {
            description: prescriptionStepDescription === null || prescriptionStepDescription === void 0 ? void 0 : prescriptionStepDescription.value,
            image: prescriptionStepImage ? prescriptionStepImage : undefined
        },
        prescriptionFormStep: {
            description: prescriptionFormStepDescription === null || prescriptionFormStepDescription === void 0 ? void 0 : prescriptionFormStepDescription.value,
            image: prescriptionFormStepImage ? prescriptionFormStepImage : undefined
        },
        packageStep: {
            readMoreLink: !!(packageStepReadMore === null || packageStepReadMore === void 0 ? void 0 : packageStepReadMore.url) ? packageStepReadMore : undefined
        },
        addOnsStep: {
            readMoreLink: !!(addOnStepReadMore === null || addOnStepReadMore === void 0 ? void 0 : addOnStepReadMore.url) ? addOnStepReadMore : undefined,
            noAddonsImage
        }
    };
}

export { getConfiguratorDocument };
//# sourceMappingURL=get-configurator-document.js.map
